module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/price-config-inactive.db687f2d.svg";